import useSettings from "./SettingsStore";

export default useSettings;
export * from './SettingsStore';